<template>
  <b-badge v-if="statusCode === 'active'" variant="success">{{ statusName }}</b-badge>
  <b-badge v-else-if="statusCode === 'pending'" variant="warning">{{ statusName }}</b-badge>
  <b-badge v-else-if="statusCode === 'suspended'" variant="danger">{{ statusName }}</b-badge>
  <b-badge v-else variant="secondary">{{ statusName }}</b-badge>
</template>

<script>
export default {
  name: "AdminCompanyStatusBadge",
  props: {
    company: {
      type: Object,
      required: true
    }
  },
  computed: {
    statusCode() {
      return this.company?.status?.code;
    },
    statusName() {
      return this.company?.status?.name;
    }
  }
}
</script>